module.exports = __webpack_public_path__ + "media/images/thieme-synaptiq-logo-2ea3506e.svg";